const key = "vTYmDtlt1lXjN0NCpWLbwrX7soUJUUHd";
const cryptLib = require('@skavinvarnan/cryptlib');

export const decryptedString = (cipherText) => {   
   return cryptLib.decryptCipherTextWithRandomIV(cipherText, key);
}
